import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.2.6_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.6_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/paging.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/imgs/Logo-mini.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/imgs/not-found-job.png");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/client.ts");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/i18n-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/components/Job/JobApplyStatusBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobFilterLoading","JobFilter"] */ "/app/src/modules/components/Job/JobFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobListLoading","JobListLayout","JobListSideLoading"] */ "/app/src/modules/components/Job/JobLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobListPaging"] */ "/app/src/modules/components/Job/JobListPaging.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobSalaryDisplay"] */ "/app/src/modules/components/Job/JobSalaryDisplay.tsx");
